<template>
    <header class="non-printable header-white" :class="isInPreferencesPage ? 'sticky': ''">
        <div class="header-wrapper">
            <div class="container">
                <div class="col-lg-2 col-xs-12 navigation-header">
                    <a href="/" class="logo">
                        <img
                            class="non-printable image-header"
                            src="@/assets/img/logo.svg"
                            alt="VentCamp"
                            width="200"
                            height="60"
                        />
                    </a>
                    <button
                        class="navbar-toggle collapsed"
                        data-toggle="collapse"
                        data-target="#menu-navigation"
                        aria-expanded="false"
                        aria-controls="navigation"
                    >
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                </div>
                
                <div class="col-lg-10 col-xs-12 navigation-container">
                    <div id="menu-navigation" class="navbar-collapse collapse">
                        <ul class="navigation-list pull-right light-text">
                            <li class="navigation-item">
                                <a class="navigation-link" href="/">Home</a>
                            </li>
                            <!-- <li class="navigation-item">
                                <a
                                    class="navigation-link"
                                    href="/auth/companies"
                                    >Companies</a
                                >
                            </li> -->
                            <li class="navigation-item">
                                <a class="navigation-link" href="/important-deadlines"
                                    >Important Deadlines</a
                                >
                            </li>
                            <li class="navigation-item">
                                <a
                                    :href="'mailto:' + conferenceTextData.conference_email"
                                    class="navigation-link"
                                    >Contact us</a
                                >
                            </li>
                            <li class="navigation-item" v-if="isLoggedIn">
                                <a
                                    href="#"
                                    class="navigation-link red-hover"
                                    style="color: #ff1212"
                                    @click.prevent="logout"
                                    >Logout</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Menubar",
    computed: {
        ...mapGetters([
            "conferenceTextData",
            "isLoggedIn"
        ]),
        isInPreferencesPage() {
            if(window.location.href.split("/").pop() == "preferences")
                return false;
            return false;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch("logout");
            this.$store.dispatch("endRegisrationProccess");
            this.$router.push("/auth/login");
        }
    }
};
</script>

<style scoped>
.logout-link {
    float: right;
    line-height: 100px;
    margin-right: 25px;
}
.navigation-link {
    text-transform: uppercase;
    font-size: 15px;
    font-weight: 400;
    transition: 0.3s;
    padding: 8px 4px !important;
}
.navigation-link:hover {
    color: #bebf07 !important;
}
.red-hover:hover {
    color: #ff1212 !important;
}
@media screen and (max-width: 74.9375em) {
    .navigation-link {
        padding: 14px 0;
    }
}
@media print {
    .non-printable {
        display: none;
    }
}
</style>
